module.exports = __webpack_public_path__ + "static/img/top5-keywords.aede359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top5-keywords.png
// module id = Rk+c
// module chunks = 1